//api/MFA/index.js
import { axios } from "../../../lib/axios";

export const setupAuthAppMFA = (data) => {
    return axios.post(`auth/setup-mfa-code-getToken`, { username: data?.username, password: data?.password });
}

export const verifyAuthAppMFA = (data) => {
    return axios.post(`auth/verify-mfa-device`, { accessToken: data?.accessToken, userCode: data?.mfaCode })
}

export const respondToAuthAppMFA = (data) => {
    return axios.post(`auth/respond-mfa`, { username: data?.username, mfaCode: data?.userResponseCode, session: data?.session, challengeName: data?.challengeName })
}

export const loginWithMFAAuthApp = (data) => {
    return axios.post(`auth/admin-login-mfa`, { mfaVerificationResponse: data?.mfaVerificationResponse, username: data?.username })
}

export const getMFASettings = (data) => {
    return axios.post(`auth/get-mfa-options`, { username: data?.username })
}

export const removeMFAAuthAppSettings = (data) => {
    return axios.post(`auth/remove-mfa`, { accessToken: data?.accessToken, challengeType: data?.challengeType })
}

export const enableSMSMfa = (data) => {
    return axios.post(`auth/enable-sms-mfa`, { username: data?.username, password: data?.password, phoneNumber: data?.phoneNumber })
}

export const getRegisterOptions = (userId, orgId) => {
    return axios.post(`auth/passkey/register/options`,{userId: userId, orgId: orgId})
}

export const verifyRegister = (userId, orgId, passkeyName ,attestResponse) => {
    return axios.post(`auth/passkey/register/verify`,{userId: userId, orgId: orgId,nameTag: passkeyName, body: attestResponse})
}

export const getLoginOptions = (userId, orgId) => {
    return axios.post(`auth/passkey/login/options`,{userId: userId, orgId: orgId})
}

export const verifyLogin = (userId, orgId, assertResponse) => {
    return axios.post(`auth/passkey/login/verify`,{userId: userId, orgId: orgId, body: assertResponse})
}

export const getPasskeyList = (userId) => {
    return axios.get(`auth/passkey/list?userId=${userId}`)
}

export const deletePasskey = (userId, credentialId) => {
    return axios.post(`auth/passkey/delete`,{userId: userId, credentialId: credentialId})
}